import { useMutation } from "@tanstack/react-query";
import { App, Button, Form, Input } from "antd";
import { FC } from "react";
import { authForgotPassword } from "../../network/auth";
import { useIntl } from "react-intl";

interface ForgotPasswordFormProps {}

const ForgotPasswordForm: FC<ForgotPasswordFormProps> = ({}) => {
  const intl = useIntl();
  const { message } = App.useApp();

  const { mutate, isLoading } = useMutation(authForgotPassword);

  const onFinish = (values: { email: string }) => {
    mutate(
      {
        email: values?.email,
      },
      {
        onSuccess: (res: any) => {
          if (res?.code !== "ERR_BAD_REQUEST") {
            message.success(intl.formatMessage({ id: "URLsentToEmail" }));
          } else {
            message.error(intl.formatMessage({ id: "emailOrPasswordIsWrong" }));
          }
        },
        onError: (err) => {
          console.log(err);
          message.error(intl.formatMessage({ id: "emailOrPasswordIsWrong" }));
        },
      }
    );
  };

  return (
    <div dir="rtl">
      <Form onFinish={onFinish} layout="vertical">
        <Form.Item
          name={"email"}
          label={intl.formatMessage({ id: "email" })}
          colon={false}
          required={false}
          hasFeedback
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: "enterEmail" }),
            },
            {
              type: "email",
              message: intl.formatMessage({ id: "invalidEmail" }),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            className="w-full my-1"
          >
            {intl.formatMessage({ id: "submit" })}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ForgotPasswordForm;
